// Auto-generated by splitter.py — do not regenerate; edit directly.

import { ArrowLeftRight, Landmark, BadgeCheck, Banknote, BarChart3, Bell, Building2, Calendar, ClipboardList, Coins, Headset, Inbox, LayoutDashboard, MapPin, MessageCircle, Newspaper, Package, Palette, PhoneCall, Plug, Scale, ScrollText, Search, ServerCog, Settings, ShieldAlert, ShieldCheck, Split, Store, Tag, Ticket, Trophy, Users, Wallet, Workflow, Wrench } from 'lucide-react';

export const NAV = [
  {
    section: null,
    items: [
      { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    ],
  },
  {
    section: 'CORE OPERATIONS',
    items: [
      { id: 'events',           label: 'Events',                icon: Calendar },
      {
        id: 'event-requests', label: 'Event Requests', icon: ClipboardList,
        // badge: 'dot'
      },
      { id: 'organizers',       label: 'Organizers',            icon: Building2 },
      { id: 'venues',           label: 'Venues',                icon: MapPin },
      // A page's tabs are declared HERE, once: the page renders them (navTabs) and ⌘K finds them
      // (constants/commandpalette). `keywords` are what an operator might type; `disabledReason` keeps a tab visible
      // but not offered.
      { id: 'tournaments',      label: 'Tournaments & Teams',   icon: Trophy, tabs: [
        { id: 'Tournaments', label: 'Tournaments', keywords: 'league cup fixtures' },
        { id: 'Teams', label: 'Teams', keywords: 'squad club' },
        // Not on the trimmed view (accessGating): the page and ⌘K both read this flag.
        { id: 'Season passes', label: 'Season passes', keywords: 'series pass', hideWhenTrimmed: true },
      ] },
    ],
  },
  {
    section: 'SALES & FINANCE',
    items: [
      {
        id: 'orders', label: 'Orders', icon: Inbox,
        // badge: 'dot'
      },
      // Splits and instalment plans are money owed TO us on an order that has not finished
      // paying — so they sit with Orders and Transactions, not under Events. The Events module
      // carries the core event record and would drown in a niche payment arrangement.
      //
      // "Payment Plans", not "Split Payments": the module holds BOTH kinds, and an operator opening
      // a page called Split Payments to find one-person instalment plans reasonably wonders whether
      // they are in the wrong place. The route is /payment-plans for the same reason; /split-payments
      // still opens it (router.js FORMER_PATHS). Saved views store only their filters, not a path.
      // The id below is internal and unchanged.
      { id: 'split-payments',   label: 'Payment Plans',         icon: Split, tabs: [
        { id: 'events', label: 'Events', keywords: 'plan events eligible tiers' },
        { id: 'splits', label: 'Splits', keywords: 'group split contributors chip in' },
        { id: 'instalments', label: 'Instalments', keywords: 'installments payment plan pay in parts' },
        { id: 'matching', label: 'Matching', disabledReason: 'No matching engine. Combining paid contributors from short splits needs fixed inventory units (`inventoryUnit` on the ticket type) and line-level contributor ownership — neither exists in this backend.' },
        { id: 'defaults', label: 'Defaults', keywords: 'plan policy rules deadline reminders' },
      ] },
      { id: 'transactions',     label: 'Transactions',          icon: ArrowLeftRight, tabs: [
        { id: 'all', label: 'All', keywords: 'every transaction payment ledger' },
        { id: 'pending', label: 'Pending', keywords: 'pending payments unconfirmed waiting' },
        { id: 'payments', label: 'Payments', keywords: 'successful paid settled' },
        { id: 'refunds', label: 'Refunds', keywords: 'money out returned' },
        { id: 'surplus', label: 'Overpaid references', keywords: 'overpaid surplus paid twice' },
        { id: 'unplaced', label: 'Unplaced money', keywords: 'dead letter not credited orphan' },
        { id: 'failed', label: 'Failed attempts', keywords: 'declined failed payments' },
      ] },
      // Finance — "what was collected, by provider and by event", and where an event gets
      // SETTLED. The route (/finance) and FinancePage were live the whole time; only this line
      // was missing, so the page was reachable by URL and by nothing else. It sits above Payouts
      // because that is the order of the work: see what came in, then pay it out.
      { id: 'finance',          label: 'Finance',               icon: Scale },
      { id: 'treasury',         label: 'Treasury',              icon: Landmark, keywords: 'money received installments unplaced refunds providers method wallets balances float where the money is', tabParam: 'section', tabs: [
        { id: 'collections', label: 'Collections', keywords: 'money received' },
        { id: 'exceptions', label: 'Exceptions', keywords: 'treasury mismatch problems' },
      ] },
      // { id: 'reconciliation',   label: 'Reconciliation',        icon: Scale, badge: 'dot' },
      {
        id: 'payouts', label: 'Payouts', icon: Banknote, tabs: [
          { id: 'event-settlements', label: 'Event settlements', keywords: 'settle organizer' },
          { id: 'queue', label: 'Payout queue' },
          { id: 'pending-approval', label: 'Waiting for a decision' },
          { id: 'processing', label: 'Approved · to send' },
          { id: 'paid', label: 'Paid' },
          { id: 'rejected', label: 'Rejected' },
          { id: 'payment-accounts', label: 'Payment accounts', keywords: 'bank mobile money destination' },
        ],
        // badge: 'dot'
      },
      { id: 'organizer-finances', label: 'Organizer Finances', icon: Wallet, keywords: 'balances owed organizer money' },
      { id: 'funding',          label: 'Funding',               icon: Coins },
      // { id: 'wallets',          label: 'Wallets',               icon: Wallet },
      { id: 'channels',         label: 'Channels',              icon: Store, tabs: [
        { id: 'box-offices', label: 'Box Offices', keywords: 'pos counter' },
        { id: 'agents', label: 'Sales Agents', keywords: 'sellers resellers' },
        { id: 'sales-channels', label: 'Sales Channels', keywords: 'attribution source whatsapp ussd web' },
      ] },
      { id: 'sales-setup',      label: 'Sales Setup',           icon: Tag, tabs: [
        { id: 'window', label: 'Sale window', keywords: 'on sale opens closes start end' },
        { id: 'channels', label: 'Channels', keywords: 'where it sells web whatsapp box office' },
        { id: 'promo', label: 'Promo codes', keywords: 'discount coupon voucher' },
        { id: 'payment', label: 'Payment & FX', keywords: 'currency exchange rate mpesa momo card methods' },
        { id: 'affiliates', label: 'Affiliates', keywords: 'referral partner tracking link' },
        { id: 'fees', label: 'Fees & commissions', keywords: 'service fee commission charges transaction fee rate percentage' },
      ] },
    ],
  },
  {
    section: 'OPERATIONS',
    items: [
      { id: 'ticketing-inventory', label: 'Ticketing & Inventory', icon: Ticket, tabs: [
        { id: 'ticketing', label: 'Ticketing', keywords: 'ticket tiers types prices' },
        { id: 'discounts', label: 'Discounts', keywords: 'promo early bird' },
        { id: 'inventory', label: 'Inventory', keywords: 'stock capacity' },
        { id: 'holds', label: 'Holds', keywords: 'reserved blocked seats' },
        { id: 'seats', label: 'Seats', keywords: 'seat map seating' },
        { id: 'admissions', label: 'Admissions', keywords: 'scans gate check in' },
        { id: 'addons', label: 'Add-ons', keywords: 'extras parking merchandise' },
      ] },
      { id: 'products',         label: 'Products',              icon: Package },
      { id: 'access-control',   label: 'Access Control',        icon: ShieldCheck, tabs: [
        { id: 'live', label: 'Live operations', keywords: 'gates scanning now' },
        { id: 'devices', label: 'Device access', keywords: 'scanners devices pair' },
        { id: 'integrations', label: 'Integrations', keywords: 'turnstile sync' },
        { id: 'incidents', label: 'Incidents', keywords: 'gate problems' },
        { id: 'reconciliation', label: 'Reconciliation', keywords: 'access sync check' },
      ] },
      // 'issues-approvals' (Issues & Approvals) removed from the sidebar — not fit for
      // its own top-level nav entry. The page + maker-checker flow remain reachable
      // programmatically (App route 'issues-approvals', e.g. from order/approval links).
      // { id: 'risk',             label: 'Risk & Compliance',     icon: ShieldAlert, badge: 'dot' },
    ],
  },
  {
    section: 'CUSTOMERS',
    items: [
      { id: 'people',           label: 'Users & Customers',     icon: Users, tabs: [
        { id: 'customers', label: 'Customers & buyers' },
        { id: 'organizer-staff', label: 'Account admins', keywords: 'admin impersonate roles' },
        { id: 'tkt-staff', label: 'Operators', keywords: 'staff team' },
        { id: 'support', label: 'Support agents' },
        { id: 'box-office', label: 'Box office', keywords: 'cashier' },
      ] },
      { id: 'accreditation',    label: 'Accreditation',         icon: BadgeCheck },
      { id: 'subscriptions',    label: 'Subscriptions',         icon: Bell, tabs: [
        { id: 'waitlist', label: 'Waitlist', keywords: 'notify me sold out' },
        { id: 'subscribers', label: 'Subscribers' },
        { id: 'form', label: 'Signup form' },
      ] },
    ],
  },
  {
    section: 'PLATFORM',
    items: [
      // Ask is not a sidebar entry: it is reached from the Reports page (its "Ask" button), where a question
      // becomes a report. /ask still resolves on a direct link; the page title falls back to the route name.
      { id: 'reports',          label: 'Reports',               icon: BarChart3, tabs: [
        { id: 'saved', label: 'Dashboards', keywords: 'saved views' },
        { id: 'library', label: 'Report library' },
        { id: 'scheduled', label: 'Scheduled', keywords: 'schedule email report' },
        { id: 'runs', label: 'Activity', keywords: 'runs history' },
        { id: 'exports', label: 'Export center', keywords: 'downloads export csv xlsx' },
      ] },
      { id: 'support',          label: 'Support',               icon: Headset, tabs: [
        { id: 'queue', label: 'Queue', keywords: 'tickets cases waiting answered escalations' },
        { id: 'issues', label: 'Issues', keywords: 'failed emails delivery errors whatsapp payment incidents retry resend' },
        { id: 'email-log', label: 'Email log', keywords: 'sent mail email address delivery status bounce ses search resend' },
        { id: 'approvals', label: 'Approvals' },
        { id: 'needs-help', label: 'Needs help', keywords: 'stuck failed pending orders' },
        { id: 'conversations', label: 'Conversations' },
        { id: 'audit', label: 'Audit trail' },
      ] },
      { id: 'call-center',      label: 'Call Center',           icon: PhoneCall },
      { id: 'chat',             label: 'Chat',                  icon: MessageCircle },
      { id: 'design',           label: 'Design & Comms',        icon: Palette, tabs: [
        { id: 'routing', label: 'Brands', keywords: 'sender domain from name' },
        { id: 'designs', label: 'Designs', keywords: 'ticket email template' },
        { id: 'campaigns', label: 'Campaigns', keywords: 'broadcast bulk sms email blast' },
        { id: 'campaign-emails', label: 'Campaign emails', keywords: 'email template html firebase handlebar newsletter' },
      ] },
      { id: 'settings',         label: 'Platform Settings',     icon: Settings },
      // Infrastructural risk, not compliance risk — automated traffic and order floods, which
      // nobody files a case for. Sits beside Audit Logs because they answer the same kind of
      // question: is something happening to this platform that nobody asked for.
      { id: 'abuse',            label: 'Abuse & Risk',          icon: ShieldAlert, tabs: [
        { id: 'signals', label: 'Signals', keywords: 'abuse bots floods attack' },
        { id: 'limits', label: 'Rate limits', keywords: 'throttle refused 429 buckets' },
      ] },
      { id: 'audit',            label: 'Audit Logs',            icon: ScrollText },
      { id: 'utilities',            label: 'Utilities',           icon: Wrench },
      // Backend Map / Reality Map: off the sidebar (and command palette, which reads
      // this same NAV) for now — bring back by uncommenting. Both routes still resolve
      // fine on a direct URL (/backend-capabilities, /functionality-reality) since
      // router.js's ROUTE_TABLE is untouched; this only hides the nav entry point.
      // { id: 'backend-capabilities', label: 'Backend Map',       icon: ServerCog },
      // { id: 'functionality-reality', label: 'Reality Map',       icon: Workflow },
      // `Plug`, not `Newspaper`: this is the ONE duplicated icon in the nav, and the page is a
      // connector — it mints a token and plugs Claude into the reporting engine. Release Notes
      // keeps Newspaper, which a changelog actually earns.
      { id: 'reports-mcp',      label: 'Reports MCP',           icon: Plug },
      { id: 'release-notes',    label: 'Release Notes',         icon: Newspaper },
    ],
  },
];

// Items hidden on the trimmed (Moments, non-full-access) nav — see accessGating.js.
// Funding/Channels/Products/Accreditation/Subscriptions + every Platform entry
// except Reports (Moments doesn't operate those modules).
const TRIMMED_HIDDEN_IDS = new Set([
  'funding', 'channels', 'products', 'accreditation', 'subscriptions',
  // 'abuse' is an INTERNAL tool while the signals are young — they have a known false-positive
  // history and a known blind spot, and neither is something to hand an operator as a verdict
  // about their buyers. Hidden here, and REFUSED by the backend (403 unless platform admin),
  // because this file is clear that trimming is not a security boundary.
  'abuse',
  'support', 'call-center', 'chat', 'design', 'settings', 'audit',
  'split-payments',
  'utilities', 'backend-capabilities', 'functionality-reality', 'release-notes', 'reports-mcp',
]);

/** Is this sidebar area off the trimmed view? The one rule the sidebar and ⌘K both apply. */
export const isHiddenWhenTrimmed = (id) => TRIMMED_HIDDEN_IDS.has(id);

export const getVisibleNav = (trimmed) => {
  if (!trimmed) return NAV;
  return NAV
    .map((group) => ({ ...group, items: group.items.filter((it) => !TRIMMED_HIDDEN_IDS.has(it.id)) }))
    .filter((group) => group.items.length > 0);
};

/**
 * A page's tabs, from its nav entry. The page renders these and ⌘K lists them, so a tab exists in
 * one place — a tab added to a page is searchable the day it lands. Pages add their own counts.
 */
export const navTabs = (id) => NAV.flatMap((g) => g.items).find((i) => i.id === id)?.tabs || [];
